import { COLORS } from '../colors';

export const labelColors = {
  '$label-accent': COLORS.romeo.$07,
  '$label-accent-dark': COLORS.romeo.$09,
  '$label-attention': COLORS.andes.$09,
  '$label-caution-dark': COLORS.fuji.$08,
  '$label-caution-light': COLORS.fuji.$06,
  '$label-dark': COLORS.zulu.$10,
  '$label-disabled': COLORS.zulu.$03,
  '$label-imported': COLORS.rocky.$09,
  '$label-light': COLORS.yuma.$01,
  '$label-link': '#227eff',
  '$label-neutral': COLORS.zulu.$06,
  '$label-placeholder': COLORS.zulu.$04,
  '$label-primary': COLORS.zulu.$08,
  '$label-success-dark': COLORS.everest.$08,
  '$label-success-light': COLORS.everest.$06,
  '$label-unclear': COLORS.montblanc.$08,
  '$label-warning-dark': COLORS.etna.$09,
  '$label-warning-light': COLORS.etna.$06,
} as const;
